export const utils = {
    checkEmptyProperties,
    convert2DatePickerDate,
    convertDate,
    convertHour,
    findObjectById,
    isCNPValid,
    isEmailValid,
    valueoremptystring,
    valueorzero,
    downloadFile,
    addOneYear,
    convertObject,
    convertArray,
    downloadFilebyName,
    saveFile,
    dateDisplay,
    datefromCNP,
    convertDateToTimeString,
    viewResponse,
    viewFile
}

function checkEmptyProperties(obj) {
    // Obține toate cheile proprietăților obiectului
    const keys = Object.keys(obj);

    // Verifică fiecare cheie dacă are valoare
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (obj[key] !== null && obj[key] != '') {
            return false; // Dacă găsim o valoare,  returnăm false
        }
    }

    return true; 
}

/* Nefolosita inca */
function convert2DatePickerDate(param) {
    if (!param) return null;
    const data = new Date(param);
    return data
}

function convertDate(sdata) {
    if (!sdata) return new Date();
    const data = new Date(sdata);
    const an = data.getFullYear();
    const luna = String(data.getMonth() + 1).padStart(2, '0');
    const zi = String(data.getDate()).padStart(2, '0');

    // Construirea stringului formatat
    return `${an}-${luna}-${zi}`;

}

function dateDisplay(sdata) {
    const data = new Date(sdata);
    const an = data.getFullYear();
    const luna = String(data.getMonth() + 1).padStart(2, '0');
    const zi = String(data.getDate()).padStart(2, '0');

    // Construirea stringului formatat
    return `${zi}.${luna}.${an}`;

}

function convertDateToTimeString(data) {
    let ore = String(data.getHours()).padStart(2, '0');
    let minute = String(data.getMinutes()).padStart(2, '0');
    let secunde = String(data.getSeconds()).padStart(2, '0');

    return `${ore}:${minute}:${secunde}`;
}


function convertHour(timeString) {
    if (!timeString) {
        return new Date();
    }
    
    if (timeString instanceof Date) {
        return timeString;
    }

    const [hours, minutes, seconds] = timeString.split(":");
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);

    return date
}

/**
 * Functie ce returneaza un obiect dintr-o lista de obiecte dupa id
 * @param {any} objectList 
 * @param {any} id
 * @returns
 */
function findObjectById (objectList, id)  {
    const foundObject = objectList.find(obj => obj.id === id);
    return foundObject || null;
};


function isCNPValid(cnp) {
    cnp = String(cnp);
    if (!cnp || cnp.length != 13) {
        return false;
    }
    for (var j = 0; j < 13; j++)
        if (cnp.substr(j, 1) < "0" || cnp.substr(j, 1) > "9") {
            return false;
        }

    if (cnp.substr(0, 1) < "1" || cnp.substr(0, 1) > "8") {
        return false;
    }

    var sex = cnp.substr(0, 1);
    var an = cnp.substr(1, 2);
    var luna = cnp.substr(3, 2);
    var zi = cnp.substr(5, 2);

    if (sex == 1 || sex == 2) {
        an = 1900 + parseInt(an)
    }
    else if (sex == 3 || sex == 4) {
        an = 1800 + parseInt(an)
    }
    else if (sex == 5 || sex == 6) {
        an = 2000 + parseInt(an)
    }

    var d = new Date(an + "-" + luna + "-" + zi);

    if ((d instanceof Date && !isNaN(d)) == false) return false;



    var sctrl = cnp.substr(0, 1) * 2 + cnp.substr(1, 1) * 7 + cnp.substr(2, 1) * 9 + cnp.substr(3, 1) * 1 + cnp.substr(4, 1) * 4 + cnp.substr(5, 1) * 6 + cnp.substr(6, 1) * 3 + cnp.substr(7, 1) * 5 + cnp.substr(8, 1) * 8 + cnp.substr(9, 1) * 2 + cnp.substr(10, 1) * 7 + cnp.substr(11, 1) * 9;
    sctrl = sctrl % 11;

    if (sctrl < 10 && cnp.substr(12, 1) == sctrl || sctrl == 10 && cnp.substr(12, 1) == 1) {
        return true;
    }
    else {
        return false;
    }

}


function isEmailValid(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;
    if (re.test(email)) {
        return true;
    }
    else {
        return false;
    }
}

function valueoremptystring( value) {
    if (!value) {
        return "";
    }
    else {
        return value;
    }
}

function valueorzero(value) {
    return (value) ? value : 0;
}

function base64ToArrayBuffer(base64){
    let binaryString = window.atob(base64);
    let len = binaryString.length;
    let bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
}


function downloadFile(base64, type){
    try {
        var arraybuffer = base64ToArrayBuffer(base64)
        var blob = new Blob([arraybuffer], { type: type });
        var url = URL.createObjectURL(blob);
        window.open(url);
    } catch (e) {
        console.log(e);
    }
}

function downloadFilebyName(base64, filename) {
    var ext = getFileExtension(filename);

    switch (ext) {
        case "pdf":
            viewFile(base64, "application/pdf");
            break;
        case "xls":
        case "xlsx":
            viewFile(base64, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
            break;
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
            viewFile(base64, "image/jpeg");
            break;
        case "txt":
            viewFile(base64, "text/plain");
            break;
        case "doc":
        case "docx":
            viewFile(base64, "application/vnd.openxmlformats-officedocument.wordprocessingml.document");
            break;
        case "zip":
            viewFile(base64, "application/zip");
            break;
        default:
            viewFile(base64, "application/octet-stream");
            break;
    }
}

function viewFile(file, type) {
    var blob = new Blob([file], { type: type });
    var url = URL.createObjectURL(blob);
    window.open(url);
}

function viewResponse(response, filename) {
    let ext = getFileExtension(filename).toLowerCase();

    var mimeType = '';
    switch (ext) {
        case "pdf":
            mimeType = 'application/pdf'
            break;
        case "jpg":
        case "jpeg":
            mimeType = 'image/jpeg'
        case "png":
            mimeType = 'image/png'
            break;
        default:
            mimeType = "application/octet-stream";
            break;
    }
    const _blob = base64ToBlob(response, mimeType);
    const _url = window.URL.createObjectURL(_blob);
    window.open(_url);

}

function base64ToBlob(base64, mimeType) {
    // Decodarea stringului base64
    const byteCharacters = atob(base64);

    // Crearea unui array de bytes
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Crearea Blob-ului
    return new Blob([byteArray], { type: mimeType });
}


function createObjectURL(object) {
    return (window.URL) ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
}

function saveFile(blob, filename) {
    const a = document.createElement('a');
    const url = createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.style.display = 'none';

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}

function getFileExtension(filename) {
    var parts = filename.split('.');
    return parts[parts.length - 1] ?? "";
}


function addOneYear(date) {
    date.setFullYear(date.getFullYear() + 1);
    date.setDate(date.getDate() - 1);
    return date;
}


function convertObject(formData, item, path){
    Object.keys(item).forEach(key =>
        formData.append(`${path}.${key}`, item[key] ?? ''));
}

function convertArray (formData, list, path) {
    for (var i = 0; i < list.length; i++) {
        convertObject(formData, list[i], `${path}[${i}]`);
    }
}


function datefromCNP(cnp) {
    if (!cnp) return new Date(2200, 1, 1);
    cnp = cnp.toString();
    var year = 1900
    const secol = cnp.slice(0, 1);
    if (secol === "3" || secol === "4") { year = 1800 }
    if (secol === "5" || secol === "6") { year = 2000 }
    const day = parseInt(cnp.slice(5, 7));
    const month = parseInt(cnp.slice(3, 5));
    year += parseInt(cnp.slice(1, 3));

    // Concatenați ziua, luna și anul într-o dată
    const dateOfBirth = new Date(year, month - 1, day);

    return dateOfBirth;
}




